const isSdkPage = (): boolean => window.location.href.indexOf(`${window.location.origin}/sdk`) >= 0;

export default isSdkPage;
